import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "SituacionConceptoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "SituacionConceptoPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexSituacionConcepto(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'ConceptoSP', name: 'c.ConceptoSP', title: 'Concepto' },
                { data: 'SituacionConcepto', name: 'sc.SituacionConcepto', title: 'Situacion Concepto' },
                { data: 'Codigo', name: 'sc.Codigo', title: 'Código' },
                { data: 'Sigla', name: 'sc.Sigla', title: 'Sigla' },
                { data: 'Descripcion', name: 'sc.Descripcion', title: 'Descripción' },
                { data: 'Activo', name: 'sc.Activo', title: 'Estado', render:function(data, type, row){
                    if (!row.Activo){ return '<i class="fa fa-ban text-danger"></i>'; }
                    else{ return '<i class="fa fa-check text-success"></i>'; }
                }},
                { data: 'ConceptoSP', name: 'sc.ConceptoSP', title: 'Concepto SP' },

                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            conceptosps: [],
            situacionconceptos: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            password: {},
            situacionconcepto: {},
            
        };
    },
    methods: {
        loadFile(input) {
            this.isLoadingFile = true;
            input = event.target;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                var data = new FormData();
                data.append('File', input.files[0]);
                this.ss.uploadFile(data)
                    .then(result => {
                        if (result.data.success) {
                            this.$bvToast.toast(
                                result.data.msg,
                                {
                                    title: 'Correcto',
                                    variant: 'info',
                                    autoHideDelay: 5000
                                }
                            )
                            this.situacionconcepto.Imagen = result.data.data;
                        } else {
                            this.$bvToast.toast(
                                result.data.msg,
                                {
                                    title: 'Oops!',
                                    variant: 'danger',
                                    autoHideDelay: 5000
                                }
                            )
                        }
                        this.isLoadingFile = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.$bvToast.toast(
                            'Error subiendo archivo',
                            {
                                title: 'Oops!',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                        this.isLoadingFile = false;
                    });
            }
        },
        getConceptoSP() {
            this.ss.listConceptoSP().then(
                (result) => {
                    let response = result.data;
                    this.conceptosps = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newSituacionConcepto() {
            this.situacionconcepto = {};
            this.$refs['frm-situacionconcepto'].show();
            // console.log("hhhhola")
        },
        showSituacionConcepto(id) {
            this.isLoading=true;
            this.ss.showSituacionConcepto(id).then(
                (result) => {
                    let response = result.data;
                    this.situacionconcepto = response.data;
                    this.$refs['view-situacionconcepto'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editSituacionConcepto() {
            this.$refs['frm-situacionconcepto'].show();
            this.$refs['view-situacionconcepto'].hide();
        },
        cancelSituacionConcepto() {
            if (this.situacionconcepto.id) {
                this.$refs['view-situacionconcepto'].show();
            }
            this.$refs['frm-situacionconcepto'].hide();
        },
        saveSituacionConcepto() {
            this.ss.storeSituacionConcepto(this.situacionconcepto).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-situacionconcepto'].hide();
                    this.$refs['datatable-situacionconcepto'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteSituacionConcepto() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroySituacionConcepto(this.situacionconcepto)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-situacionconcepto'].hide();
                                this.$refs['datatable-situacionconcepto'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-situacionconcepto'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-situacionconcepto'].show();
        },
        changePassword() {
            this.password.SituacionConcepto = this.situacionconcepto.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-situacionconcepto'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-SituacionConcepto').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showSituacionConcepto(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } else {
            // this.getRol();
            this.getConceptoSP();
        }
    }
};
